import { useState, useEffect } from "react";
import {
  FileDown,
  Plus,
  Send,
  Bell,
  RefreshCcw,
  Trash,
  Pen,
  Eye,
  X,
} from "lucide-react";
import { exportAnyJsonToExcel } from "../Utils/exportAnyJsonToExcel";
import { Toaster, toast } from "sonner";
import axios from "axios";
import { useGlobalContext } from "../../GlobalContext";
import AddDriverModal from "./AddDriverModal";
import LoadingScreen from "../Utils/LoadingScreen";
import * as Dialog from "@radix-ui/react-dialog";
import EditDriverModal from "./EditDriverModal";
import SendNotificationModal from "./SendNotificationModal";
import BulkSendNotificationModal from "./BulkSendNotificationModal";
import imageCompression from "browser-image-compression";
import ViewKycDetails from "./ViewKycDetails";
import EditKycModal from './EditKycModal';
import TablePagination from "../Utils/TablePagination";
import { Settings, Info } from "lucide-react";
import DriverConfigModal from "./DriverConfigModal";
import DriverDetailsModal from "./DriverDetailsModal";
import DriverConfigTable from "./DriverConfigTable";
import DriverConfigQuickAddModal from "./DriverConfigQuickAddModal";
import DriverChargesBoard from "./DriverChargesBoard";
import DriverChargesModal from "./DriverChargesModal";




export default function DriversPage() {
  const { baseurl, token, accessToken, setIsUnauthorised, teams, AdminId } = useGlobalContext();
  const [Loading, setLoading] = useState(false);
  const [drivers, setDrivers] = useState([]);
  const [kycDrivers, setKycDrivers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeTab, setActiveTab] = useState("list");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  const [editKycModalOpen, setEditKycModalOpen] = useState(false);
  const [editDriver, setEditDriver] = useState(null);
  const [notificationDriver, setNotificationDriver] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [editKycDriver, setEditKycDriver] = useState(null);
  const [updatingDutyId, setUpdatingDutyId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [kycStatusLoading, setKycStatusLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [openDialogId, setOpenDialogId] = useState(null);
  const [openKycDialogId, setOpenKycDialogId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [driverKycStatus, setDriverKycStatus] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [kycFormdata, setKycFormData] = useState({
    driver_code: "",
    email: "",
    phone: "",
    aadhaar_no: "",
    pan_no: "",
    driving_licence: "",
    transport_type_id: "",
    transport_description: "",
    licence_plate: "",
    city: "",
    area: "",
    profile_photo: null,
    aadhaar_front: null,
    aadhaar_back: null,
    pan_front: null,
    driving_licence_img: null,
    vehicle_name_plate_img: null,
  });
  const [configTabRows, setConfigTabRows] = useState([]);
  const [configTabLoading, setConfigTabLoading] = useState(false);

  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [configDriverCode, setConfigDriverCode] = useState("");

  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [detailsDriver, setDetailsDriver] = useState(null);

  const [deletingConfigId, setDeletingConfigId] = useState(null);
  const [configSearch, setConfigSearch] = useState("");
  const [quickConfigOpen, setQuickConfigOpen] = useState(false);
  const [chargesTabRows, setChargesTabRows] = useState([]);
  const [chargesTabLoading, setChargesTabLoading] = useState(false);
  const [chargesSearch, setChargesSearch] = useState("");
  const [chargesModalOpen, setChargesModalOpen] = useState(false);
  const [chargesDriverCode, setChargesDriverCode] = useState(""); // for edit-from-card



  const driversPerPage = 25;

  const filteredDrivers = drivers?.filter((driver) => {
    const matchSearch =
      driver.fullName?.toLowerCase().includes(search.toLowerCase()) ||
      driver.username?.toLowerCase().includes(search.toLowerCase());
    const matchTeam = selectedTeam ? driver.teamName === selectedTeam : true;
    const matchStatus = selectedStatus ? driver.status === selectedStatus : true;
    return matchSearch && matchTeam && matchStatus;
  });

  const filteredKycDrivers = kycDrivers?.filter((driver) => {
    const searchLower = search.toLowerCase();
    return [
      driver.email,
      driver.driver_code,
      driver.aadhaar_no,
      driver.area,
      driver.city,
      driver.driving_licence,
      driver.licence_plate,
      driver.pan_no,
      driver.phone,
      driver.transport_description,
      driver.transport_type_id,
    ].some((field) => field?.toLowerCase().includes(searchLower));
  });

  const indexOfLast = currentPage * driversPerPage;
  const indexOfFirst = indexOfLast - driversPerPage;
  const currentDrivers = filteredDrivers?.slice(indexOfFirst, indexOfLast);
  const currentKycDrivers = filteredKycDrivers?.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredDrivers?.length / driversPerPage);
  const totalKycPages = Math.ceil(filteredKycDrivers?.length / driversPerPage);

  useEffect(() => {
    FetchDriverCall();
  }, []);

  useEffect(() => {
    if (activeTab === "Kyc Details") FetchDriverKycDetails();
  }, [activeTab]);

  useEffect(() => {
    if (editKycDriver && editKycModalOpen) {
      setKycFormData({
        driver_code: editKycDriver.driverId || editKycDriver.driver_code || "",
        email: editKycDriver.email || "",
        phone: editKycDriver.phone || "",
        city: editKycDriver.city || "",
        area: editKycDriver.area || "",
        profile_photo: editKycDriver.profilePicture || editKycDriver.profile_photo || null,
        aadhaar_no: editKycDriver.aadharNumber || editKycDriver.aadhaar_no || "",
        aadhaar_front: editKycDriver.aadharFrontPhoto || editKycDriver.aadhaar_front || null,
        aadhaar_back: editKycDriver.aadharBackPhoto || editKycDriver.aadhaar_back || null,
        pan_no: editKycDriver.panCard || editKycDriver.pan_no || "",
        pan_front: editKycDriver.panCardFrontPhoto || editKycDriver.pan_front || null,
        driving_licence: editKycDriver.drivingLicenseNumber || editKycDriver.driving_licence || "",
        driving_licence_img: editKycDriver.drivingLicenseFrontPhoto || editKycDriver.driving_licence_img || null,
        transport_type_id: editKycDriver.transportTypeID || editKycDriver.transport_type_id || "",
        transport_description: editKycDriver.transportDescription || editKycDriver.transport_description || "",
        licence_plate: editKycDriver.licensePlate || editKycDriver.licence_plate || "",
        vehicle_name_plate_img: editKycDriver.licensePlatePhoto || editKycDriver.vehicle_name_plate_img || null,
      });
      setCurrentStep(1);
    }
  }, [editKycDriver, editKycModalOpen]);

  const FetchDriverCall = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const UserDetail = { userid: "", adminId: AdminId };
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getDriverList`,
        UserDetail,
        { headers: { Authorization: `Basic ${token}` } }
      );
      if (response.data.responseCode === "00") {
        setDrivers(response.data.data);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching Driver");
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const FetchDriverKycDetails = async (preserveLocalUpdates = true) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverKycDetails`,
        { userid: "", adminId: AdminId },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        const serverData = response.data.data;

        if (preserveLocalUpdates) {
          setKycDrivers(prevDrivers => {
            return serverData.map(serverDriver => {
              const localDriver = prevDrivers.find(d =>
                d.id === serverDriver.id || d.driver_code === serverDriver.driver_code
              );

              if (localDriver &&
                (localDriver.status === "Approved" || localDriver.status === "Rejected") &&
                serverDriver.status === "Pending") {
                return { ...serverDriver, status: localDriver.status };
              }
              return serverDriver;
            });
          });
        } else {
          setKycDrivers(serverData);
        }
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      console.error('Error fetching Driver KYC Details:', error);
      toast.error("Error fetching Driver KYC Details");
    } finally {
      setLoading(false);
    }
  };


  const handleKycAction = async (kycId, action = "view", status = "") => {
    setKycStatusLoading(true);
    try {
      const payload = {
        kycId: kycId.toString(),
        kycStatus: action === "view" ? "" : status, adminId: AdminId
      };

      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/verifyDriverkycDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        if (action === "view") {
          const kycData = response.data.data;
          setDriverKycStatus(kycData);
          return kycData;
        } else {
          return {
            success: true,
            responseCode: response.data.responseCode,
            message: response.data.responseMessage
          };
        }
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
        throw new Error("Unauthorized");
      } else {
        console.error('API Error:', response.data);
        toast.error(response.data.responseMessage || "Error processing KYC request");
        throw new Error(response.data.responseMessage || "API Error");
      }
    } catch (error) {
      console.error(`Error ${action === "view" ? "fetching" : "updating"} KYC details:`, error);
      throw error;
    } finally {
      setKycStatusLoading(false);
    }
  };

  const handleConfirmDelete = async (driverId) => {
    setDeletingId(driverId);
    try {
      const response = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriver`,
        { driverId, adminId: AdminId },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (response.data.responseCode === "00") {
        setDrivers((prev) => prev.filter((d) => d.driverId !== driverId));
        toast.success(response.data.responseMessage);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(response.data.responseMessage || "Failed to delete driver");
      }
    } catch (err) {
      toast.error("Error occurred while deleting driver");
    } finally {
      setDeletingId(null);
      setOpenDialogId(null);
      FetchDriverCall();
    }
  };

  const handleToggleDutyStatus = async (driver, isCurrentlyOn) => {
    const next = isCurrentlyOn ? "off_duty" : "on_duty";
    const current = isCurrentlyOn ? "on_duty" : "off_duty";

    setUpdatingDutyId(driver.driverId);
    setDrivers((prev) =>
      prev.map((d) =>
        d.driverId === driver.driverId ? { ...d, dutyStatus: next } : d
      )
    );

    try {
      const payload = {
        device: "Admin",
        userId: "",
        driverId: driver.driverId,
        dutyValue: next, adminId: AdminId
      };

      const response = await axios.post(
        `${baseurl}/api/User/v1.0/updateDriverDutyTime`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (response.data.responseCode === "00") {
        toast.success(`Duty updated: ${next.replace("_", " ")}`);
        FetchDriverCall(true);
      } else if (response.data.responseCode === "401") {
        setIsUnauthorised(true);
        setDrivers((prev) =>
          prev.map((d) =>
            d.driverId === driver.driverId ? { ...d, dutyStatus: current } : d
          )
        );
      } else {
        toast.error(response.data.responseMessage || "Failed to update duty");
        setDrivers((prev) =>
          prev.map((d) =>
            d.driverId === driver.driverId ? { ...d, dutyStatus: current } : d
          )
        );
      }
    } catch {
      toast.error("Error updating duty status");
      setDrivers((prev) =>
        prev.map((d) =>
          d.driverId === driver.driverId ? { ...d, dutyStatus: current } : d
        )
      );
    } finally {
      setUpdatingDutyId(null);
    }
  };

  const handleEyeClick = async (driver) => {
    setSelectedDriver(driver);
    const kycId = driver.id;
    setOpenKycDialogId(kycId);
    setDriverKycStatus(null);

    if (kycId) {
      const kycDetails = await handleKycAction(kycId, "view");
      if (kycDetails) {
        setSelectedDriver(prev => ({ ...prev, ...kycDetails }));
      }
    }
  };

  const handleKycStatusUpdate = async (kycId, status,) => {
    const result = await handleKycAction(kycId, "update", status);
    if (result) {
      setTimeout(() => {
        if (activeTab === "Kyc Details") {
          FetchDriverKycDetails();
        }
      }, 500);
    }
  };

  const handleEditKyc = (driverKycData) => {
    setEditKycDriver(driverKycData);
    setEditKycModalOpen(true);
  };

  const handleFileChange = (fieldName, file) => {
    setKycFormData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };
  const filteredConfigRows = (configTabRows || []).filter((r) => {
    const q = configSearch.trim().toLowerCase();
    if (!q) return true;

    return [
      r.driver_code,
      r.name,
      r.team_name,
      r.driver_type,
      String(r.cash_limit ?? ""),
      String(r.daily_task_limit ?? ""),
    ].some((v) => String(v || "").toLowerCase().includes(q));
  });


  const handleDriverSelect = (e) => {
    const selectedDriverCode = e.target.value;
    const selectedDriver = drivers.find(
      (driver) => driver.driverId === selectedDriverCode
    );

    if (selectedDriver) {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: selectedDriverCode,
        email: selectedDriver.email || "",
        phone: selectedDriver.phone || "",
      }));
    } else {
      setKycFormData((prev) => ({
        ...prev,
        driver_code: "",
        email: "",
        phone: "",
      }));
    }
  };

  const resetForm = () => {
    setKycFormData({
      driver_code: "",
      email: "",
      phone: "",
      aadhaar_no: "",
      pan_no: "",
      driving_licence: "",
      transport_type_id: "",
      transport_description: "",
      licence_plate: "",
      city: "",
      area: "",
      profile_photo: null,
      aadhaar_front: null,
      aadhaar_back: null,
      pan_front: null,
      driving_licence_img: null,
      vehicle_name_plate_img: null,
    });
  };

  const closeKycModal = () => {
    setEditKycModalOpen(false);
    setEditKycDriver(null);
    setCurrentStep(1);
    resetForm();
  };

  const closeModel = () => {
    setOpenKycDialogId(null);
    setSelectedDriver(null);
    setDriverKycStatus(null);
  };

  const populateEditForm = (driver) => {
    setKycFormData({
      driver_code: driver.driver_code || "",
      email: driver.email || "",
      phone: driver.phone || "",
      aadhaar_no: driver.aadhaar_no || "",
      pan_no: driver.pan_no || "",
      driving_licence: driver.driving_licence || "",
      transport_type_id: driver.transport_type_id || "",
      transport_description: driver.transport_description || "",
      licence_plate: driver.licence_plate || "",
      city: driver.city || "",
      area: driver.area || "",
      profile_photo: driver.profile_photo || null,
      aadhaar_front: driver.aadhaar_front || null,
      aadhaar_back: driver.aadhaar_back || null,
      pan_front: driver.pan_front || null,
      driving_licence_img: driver.driving_licence_img || null,
      vehicle_name_plate_img: driver.vehicle_name_plate_img || null,
    });
    setEditKycModalOpen(true);
    setEditKycDriver(driver);
  };

  const compressImageMax = async (file) => {
    try {
      const options = {
        maxSizeMB: 0.1,
        maxWidthOrHeight: 600,
        useWebWorker: true,
        fileType: "image/jpeg",
        quality: 0.7,
        initialQuality: 0.7,
      };

      const compressedFile = await imageCompression(file, options);

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          let base64 = reader.result;
          base64 = base64.replace(/^data:image\/(jpeg|png|webp|jpg);base64,/, "");
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
      });
    } catch (error) {
      console.error("Image compression failed:", error);
      throw error;
    }
  };

  const uploadImageToServer = async (imageFile, driverCode, imageType) => {
    if (typeof imageFile === "string") {
      return imageFile;
    }

    try {
      const compressedBase64 = await compressImageMax(imageFile);

      const uploadPayload = {
        userid: driverCode,
        item_name: `${driverCode}_${imageType}`,
        image_data: compressedBase64,
        type: imageType, adminId: AdminId
      };

      const response = await axios.post(
        `https://bumppy.in/packky/api/v1/uploadKycImage.php`,
        uploadPayload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && (response.data.status === "0" || response.data.status === 0)) {
        const imageUrl = response.data.image_url || `${baseurl}/uploads/kyc/${driverCode}_${imageType}.jpg`;
        return imageUrl;
      } else {
        throw new Error(response.data.msg || "Upload failed");
      }
    } catch (error) {
      console.error(`Image upload failed for ${imageType}:`, error);
      throw error;
    }
  };

  const handleStepSubmit = async (stepNumber, stepData) => {
    try {
      setLoading(true);

      const payload = {
        userid: kycFormdata.driver_code
        , adminId: AdminId,
        step: stepNumber.toString(),
        ...stepData,
      };

      const response = await axios.post(
        `${baseurl}/api/Driver/v2.0/addDriverKYCDetails`,
        payload,
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.responseCode === "00") {
        toast.success(`Step ${stepNumber} data saved successfully!`);
        if (stepNumber === 6) {
          toast.success("All KYC steps completed successfully!");
          setTimeout(() => {
            setEditKycModalOpen(false);
            setEditKycDriver(null);
            setCurrentStep(1);
            resetForm();

            if (activeTab === "Add Kyc Data" || activeTab === "Kyc Details") {
              FetchDriverKycDetails();
            }
          }, 2000);
        }
        return true;
      } else {
        toast.error(response.data.responseMessage || `Failed to save step ${stepNumber}`);
        return false;
      }
    } catch (error) {
      console.error(`Step ${stepNumber} submission error:`, error);
      toast.error(`Error saving step ${stepNumber} data`);
      return false;
    } finally {
      setLoading(false);
    }
  };
  const fetchAllDriverConfigs = async (silent = false) => {
    if (!silent) setConfigTabLoading(true);
    try {
      const payload = { adminId: AdminId, driverCode: "" };
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/getAllDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        setConfigTabRows(res.data.data || []);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch configurations");
      }
    } catch (e) {
      toast.error("Error fetching configurations");
    } finally {
      if (!silent) setConfigTabLoading(false);
    }
  };
  const fetchDriverCharges = async (silent = false) => {
    if (!silent) setChargesTabLoading(true);
    try {
      const res = await axios.post(
        `${baseurl}/api/Transactions/v1.0/getDriverCharges`,
        { driverCode: "" },
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        const raw = res.data.data || [];

        // enrich with name/team from driver list
        const normalized = raw.map((g) => {
          const d = drivers.find((x) => x.driverId === g.driverCode);
          const charges = g.charges || [];
          const per_day = charges.find((c) => c.type === "per_day") || null;
          const per_order = charges.find((c) => c.type === "per_order") || null;

          return {
            driverCode: g.driverCode,
            name: d?.fullName || d?.username || "",
            teamName: d?.teamName || "",
            per_day: per_day ? { id: per_day.id, amount: per_day.amount } : null,
            per_order: per_order ? { id: per_order.id, amount: per_order.amount } : null,
          };
        });

        setChargesTabRows(normalized);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to fetch driver charges");
      }
    } catch (e) {
      toast.error("Error fetching driver charges");
    } finally {
      if (!silent) setChargesTabLoading(false);
    }
  };

  const handleDeleteConfig = async (configId) => {
    const ok = window.confirm("Are you sure you want to delete this configuration?");
    if (!ok) return;

    setDeletingConfigId(String(configId));
    try {
      const payload = { adminId: AdminId, configId: String(configId) };
      const res = await axios.post(
        `${baseurl}/api/Driver/v1.0/deleteDriverConfigDetails`,
        payload,
        { headers: { Authorization: `Basic ${token}` } }
      );

      if (res.data.responseCode === "00") {
        toast.success(res.data.responseMessage || "Deleted");
        fetchAllDriverConfigs(true);
      } else if (res.data.responseCode === "401") {
        setIsUnauthorised(true);
      } else {
        toast.error(res.data.responseMessage || "Failed to delete config");
      }
    } catch (e) {
      toast.error("Error deleting config");
    } finally {
      setDeletingConfigId(null);
    }
  };
  useEffect(() => {
    if (activeTab === "Configuration") fetchAllDriverConfigs();
  }, [activeTab]);

  const renderDriversTable = () => (
    <div className="overflow-x-auto border rounded-md shadow-sm">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-orange-400 text-left text-sm font-semibold text-white">
            <th className="px-4 py-2 text-center">S/N</th>
            <th className="px-4 py-2 text-center">Driver ID</th>
            <th className="px-4 py-2 text-center">User Name</th>
            <th className="px-4 py-2 text-center">Name</th>
            <th className="px-4 py-2 text-center">Email</th>
            <th className="px-4 py-2 text-center">Phone</th>
            <th className="px-4 py-2 text-center">Last Login</th>
            <th className="px-4 py-2 text-center">Vehicle</th>
            {/* <th className="px-4 py-2 text-center">Device</th> */}
            <th className="px-4 py-2 text-center">Duty Status</th>
            <th className="px-4 py-2 text-center">Status</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentDrivers?.map((driver, index) => (
            <tr key={driver.id} className="text-sm border-t">
              <td className="px-4 py-2 text-center">{indexOfFirst + index + 1}</td>
              <td className="px-4 py-2 text-center">{driver.driverId}</td>
              <td className="px-4 py-2 text-center">{driver.username}</td>
              <td className="px-4 py-2 font-medium text-center">{driver.fullName}</td>
              <td className="px-4 py-2 text-center">{driver.email}</td>
              <td className="px-4 py-2 text-center">{driver.phone}</td>
              <td className="px-4 py-2 text-center">{driver.last_login}</td>
              <td className="px-4 py-2 text-center">{driver.transport_type}</td>
              {/* <td className="px-4 py-2 text-center">{driver.device_platform}</td> */}
              <td className="px-4 py-2 text-center">
                {(() => {
                  const isOn = driver.dutyStatus === "active";
                  const disabled = updatingDutyId === driver.driverId;

                  return (
                    <label className={`relative inline-flex items-center ${disabled ? "opacity-60 pointer-events-none" : "cursor-pointer"}`}>
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={isOn}
                        onChange={() => !disabled && handleToggleDutyStatus(driver, isOn)}
                        disabled={disabled}
                        aria-checked={isOn}
                        aria-label="Toggle duty status"
                      />
                      <div className={["w-10 h-5 rounded-full transition-colors duration-300", "bg-gray-300 peer-checked:bg-green-500", "ring-0 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-green-400"].join(" ")} />
                      <span className={["absolute left-0.5 top-0.5 h-4 w-4 rounded-full bg-white shadow", "transition-transform duration-300", "peer-checked:translate-x-[1.25rem]"].join(" ")} />
                    </label>
                  );
                })()}
              </td>
              <td className="px-4 py-2 text-center">
                <span className={`px-2 py-1 rounded-full text-xs font-semibold ${driver.status === "active" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                  {driver.status.charAt(0).toUpperCase() + driver.status.slice(1)}
                </span>
              </td>
              <td className="px-4 py-2">
                <div className="flex gap-2 justify-center items-center">
                  <button
                    className="text-green-600 hover:text-green-800"
                    onClick={() => {
                      setNotificationDriver(driver);
                      setNotificationModalOpen(true);
                    }}
                  >
                    <Bell size={14} />
                  </button>

                  <Dialog.Root
                    open={openDialogId === driver.driverId}
                    onOpenChange={(open) => setOpenDialogId(open ? driver.driverId : null)}
                  >
                    <Dialog.Trigger asChild>
                      <button className="text-red-600 hover:text-red-800">
                        <Trash size={14} />
                      </button>
                    </Dialog.Trigger>
                    <Dialog.Portal>
                      <Dialog.Overlay className="fixed inset-0 bg-black/40 z-50" />
                      <Dialog.Content className="bg-white rounded-md shadow-lg p-6 w-[90%] max-w-sm fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-50">
                        <Dialog.Title className="text-lg font-semibold mb-2">Confirm Deletion</Dialog.Title>
                        <Dialog.Description className="text-sm text-gray-600 mb-4">
                          Are you sure you want to delete driver <strong>{driver.fullName}</strong>?
                        </Dialog.Description>
                        <div className="flex justify-end gap-2">
                          <Dialog.Close asChild>
                            <button className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 text-sm">Cancel</button>
                          </Dialog.Close>
                          <button
                            onClick={() => handleConfirmDelete(driver.driverId)}
                            className="px-3 py-1 rounded bg-red-600 hover:bg-red-700 text-white text-sm disabled:opacity-50"
                            disabled={deletingId === driver.driverId}
                          >
                            {deletingId === driver.driverId ? "Deleting..." : "Yes, Delete"}
                          </button>
                        </div>
                      </Dialog.Content>
                    </Dialog.Portal>
                  </Dialog.Root>

                  <button
                    className="text-blue-600 hover:text-blue-800"
                    onClick={() => {
                      setEditDriver(driver);
                      setEditModalOpen(true);
                    }}
                  >
                    <Pen size={14} />
                  </button>
                  {/* Details */}
                  <button
                    className="text-gray-700 hover:text-gray-900"
                    title="Driver Details"
                    onClick={() => {
                      setDetailsDriver(driver);
                      setDetailsModalOpen(true);
                    }}
                  >
                    <Info size={14} />
                  </button>

                  {/* Config */}
                  <button
                    className="text-orange-600 hover:text-orange-800"
                    title="Driver Configuration"
                    onClick={() => {
                      setConfigDriverCode(driver.driverId);
                      setConfigModalOpen(true);
                    }}
                  >
                    <Settings size={14} />
                  </button>

                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderKycTable = () => (
    <div className="overflow-x-auto border rounded-md shadow-sm">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-orange-400 text-left text-sm font-semibold text-white">
            <th className="px-4 py-2 text-center">S/N</th>
            <th className="px-4 py-2 text-center">Driver ID</th>
            <th className="px-4 py-2 text-center">Name</th>
            <th className="px-4 py-2 text-center">Phone</th>
            <th className="px-4 py-2 text-center">Aadhar Number</th>
            <th className="px-4 py-2 text-center">Pan No</th>
            <th className="px-4 py-2 text-center">Driving Licence</th>
            <th className="px-4 py-2 text-center">Transport Type</th>
            <th className="px-4 py-2 text-center">Licence Plate</th>
            <th className="px-4 py-2 text-center">City</th>
            <th className="px-4 py-2 text-center">KYC Status</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentKycDrivers?.map((driver, index) => (
            <tr key={driver.driver_code || driver.id} className="text-sm border-t">
              <td className="px-4 py-2 text-center">{indexOfFirst + index + 1}</td>
              <td className="px-4 py-2 text-center">{driver.driver_code || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.name || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.phone || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.aadhaar_no || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.pan_no || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.driving_licence || "N/A"}</td>
              <td className="px-4 py-2 text-center">
                {driver.transport_type_id || "N/A"} ({driver.transport_description || "N/A"})
              </td>
              <td className="px-4 py-2 text-center">{driver.licence_plate || "N/A"}</td>
              <td className="px-4 py-2 text-center">{driver.city || "N/A"}</td>
              <td className="px-4 py-2 text-center">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-semibold ${driver.status === "Approved"
                    ? "bg-green-100 text-green-700"
                    : driver.status === "Rejected"
                      ? "bg-red-100 text-red-700"
                      : "bg-yellow-100 text-yellow-700"
                    }`}
                >
                  {driver.status || "Pending"}
                </span>
              </td>
              <td className="px-4 py-2 text-center">
                <div className="flex gap-4 justify-center items-center">
                  <button
                    className="text-gray-500 hover:text-gray-700"
                    title="Show Details"
                    onClick={() => handleEyeClick(driver)}
                  >
                    <Eye size={18} />
                  </button>
                  <button
                    className="text-blue-600 hover:text-blue-800"
                    onClick={() => {
                      setEditKycDriver(driver);
                      populateEditForm(driver);
                      setEditKycModalOpen(true);
                    }}
                  >
                    <Pen size={14} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderTabNavigation = () => (
    <div className="mb-4 border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        <button
          onClick={() => setActiveTab("list")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "list"
            ? "border-orange-600 text-orange-600"
            : "border-transparent text-gray-600"
            }`}
        >
          Driver
        </button>
        <button
          onClick={() => setActiveTab("Kyc Details")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "Kyc Details"
            ? "border-orange-600 text-orange-600"
            : "border-transparent text-gray-600"
            }`}
        >
          Kyc Details
        </button>
        <button
          onClick={() => setActiveTab("Configuration")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "Configuration"
            ? "border-orange-600 text-orange-600"
            : "border-transparent text-gray-600"
            }`}
        >
          Configuration
        </button>
        <button
          onClick={() => setActiveTab("Driver Charges")}
          className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${activeTab === "Driver Charges"
              ? "border-orange-600 text-orange-600"
              : "border-transparent text-gray-600"
            }`}
        >
          Driver Charges
        </button>


      </nav>
    </div>
  );

  const renderSearchAndFilters = () => (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
      <div className="flex flex-wrap items-end gap-2">
        {activeTab !== "Configuration" ? (
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={
              activeTab === "Kyc Details"
                ? "Search by email or drive code..."
                : "Search name or username..."
            }
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        ) : (
          <input
            type="text"
            value={configSearch}
            onChange={(e) => setConfigSearch(e.target.value)}
            placeholder="Search config by driver code, name, team..."
            className="px-2 py-1 border rounded text-xs shadow-sm w-[220px]"
            autoComplete="off"
          />
        )}
      </div>

      {activeTab === "list" && renderDriverActions()}
      {activeTab === "Kyc Details" && renderKycActions()}

      {activeTab === "Configuration" && (
        <div className="flex flex-wrap items-end gap-2">
          <button
            className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => setQuickConfigOpen(true)}
          >
            <Plus size={14} />
            <span>Add Config</span>
          </button>


          <button
            className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => fetchAllDriverConfigs()}
          >
            <RefreshCcw size={14} />
            <span>Refresh</span>
          </button>
        </div>
      )}
      {activeTab === "Driver Charges" && (
        <div className="flex flex-wrap items-end gap-2">
          <button
            className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => {
              setChargesDriverCode("");
              setChargesModalOpen(true);
            }}
          >
            <Plus size={14} />
            <span>Add Charges</span>
          </button>

          <button
            className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
            onClick={() => fetchDriverCharges()}
          >
            <RefreshCcw size={14} />
            <span>Refresh</span>
          </button>
        </div>
      )}

    </div>
  );


  const renderDriverActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedTeam}
        onChange={(e) => setSelectedTeam(e.target.value)}
      >
        <option value="">All Teams</option>
        {teams?.map((team) => (
          <option key={team.id} value={team.team_name}>
            {team.team_name}
          </option>
        ))}
      </select>

      <select
        className="text-xs border rounded px-2 py-1 shadow-sm w-[130px]"
        value={selectedStatus}
        onChange={(e) => setSelectedStatus(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="active">Active</option>
        <option value="offline">Offline</option>
      </select>

      <button
        className="flex items-center space-x-1 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() =>
          exportAnyJsonToExcel({
            data: drivers,
            filePrefix: "DriversExport",
            sheetName: "DriversList",
          })
        }
      >
        <FileDown size={14} />
        <span>Export</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setModalOpen(true)}
      >
        <Plus size={14} />
        <span>Add Driver</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => setBulkOpen(true)}
      >
        <Send size={14} />
        <span>Send Bulk</span>
      </button>

      <button className="flex items-center space-x-1 bg-orange-500 hover:bg-orange-600 text-white px-3 py-1.5 rounded text-xs shadow">
        <Bell size={14} />
        <span>Push</span>
      </button>

      <button
        className="flex items-center space-x-1 bg-gray-500 hover:bg-gray-600 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => FetchDriverCall()}
      >
        <RefreshCcw size={14} />
        <span>Refresh</span>
      </button>
    </div>
  );

  const renderKycActions = () => (
    <div className="flex flex-wrap items-end gap-2">
      <button
        className="flex items-center space-x-1 bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-xs shadow"
        onClick={() => {
          setEditKycDriver(null);
          resetForm();
          setCurrentStep(1);
          setEditKycModalOpen(true);
        }}
      >
        <Plus size={14} />
        <span>Add KYC</span>
      </button>
    </div>
  );

  const renderPagination = () => {
    const totalCount =
      activeTab === "list"
        ? filteredDrivers?.length || 0
        : filteredKycDrivers?.length || 0;

    return (
      <TablePagination
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={driversPerPage}
        onPageChange={setCurrentPage}
      />
    );
  };


  const renderModals = () => {
    const isAnyModalOpen =
      modalOpen ||
      editModalOpen ||
      notificationModalOpen ||
      bulkOpen ||
      editKycModalOpen ||
      !!selectedDriver ||
      configModalOpen ||
      detailsModalOpen ||
      quickConfigOpen ||
      chargesModalOpen;

    if (!isAnyModalOpen) return null;

    return (
      <>
        <AddDriverModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          Refesh={FetchDriverCall}
          AdminId={AdminId}
        />

        <EditDriverModal
          isOpen={editModalOpen}
          onClose={() => setEditModalOpen(false)}
          driver={editDriver}
          onDriverUpdated={FetchDriverCall}
          AdminId={AdminId}
        />

        <SendNotificationModal
          isOpen={notificationModalOpen}
          onClose={() => setNotificationModalOpen(false)}
          driver={notificationDriver}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
        />

        <BulkSendNotificationModal
          isOpen={bulkOpen}
          onClose={() => setBulkOpen(false)}
          drivers={drivers}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          AdminId={AdminId}
        />

        <EditKycModal
          editKycModalOpen={editKycModalOpen}
          setEditKycModalOpen={setEditKycModalOpen}
          editKycDriver={editKycDriver}
          setEditKycDriver={setEditKycDriver}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          kycFormdata={kycFormdata}
          setKycFormData={setKycFormData}
          drivers={drivers}
          handleDriverSelect={handleDriverSelect}
          handleFileChange={handleFileChange}
          handleStepSubmit={handleStepSubmit}
          uploadImageToServer={uploadImageToServer}
          resetForm={resetForm}
          Loading={Loading}
          onSuccess={() => {
            if (activeTab === "Kyc Details") {
              FetchDriverKycDetails();
            }
          }}
          activeTab={activeTab}
          FetchDriverKycDetails={FetchDriverKycDetails}
          AdminId={AdminId}
        />

        <ViewKycDetails
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          selectedDriver={selectedDriver}
          setSelectedDriver={setSelectedDriver}
          setDriverKycStatus={setDriverKycStatus}
          previewImage={previewImage}
          setPreviewImage={setPreviewImage}
          kycStatusLoading={setKycStatusLoading}
          driverKycStatus={setDriverKycStatus}
          setKycDrivers={setKycDrivers}
          closeModel={() => setEditKycModalOpen(false)}
          setLoading={setLoading}
          setEditKycModalOpen={setEditKycModalOpen}
          setEditKycDriver={setEditKycDriver}
          setCurrentStep={setCurrentStep}
          activeTab={activeTab}
          setKycStatusLoading={setKycStatusLoading}
          kycFormdata={editKycDriver || {}}
          resetForm={resetForm}
          handleKycAction={handleKycAction}
          openKycDialogId={openKycDialogId}
          setOpenKycDialogId={setOpenKycDialogId}
          FetchDriverKycDetails={FetchDriverKycDetails}
          AdminId={AdminId}
          handleStepSubmit={(step, stepData) =>
            handleStepSubmit(
              baseurl,
              token,
              editKycDriver || {},
              step,
              stepData,
              resetForm,
              setLoading,
              setEditKycModalOpen,
              setEditKycDriver,
              setCurrentStep,
              activeTab,
              () =>
                FetchDriverKycDetails(
                  baseurl,
                  token,
                  setIsUnauthorised,
                  setKycDrivers,
                  setLoading
                )
            )
          }
        />
        <DriverConfigModal
          open={configModalOpen}
          onOpenChange={setConfigModalOpen}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          adminId={AdminId}
          driverCode={configDriverCode}
          onSuccess={() => {
            // refresh config tab + keep driver list unchanged
            if (activeTab === "Configuration") fetchAllDriverConfigs(true);
          }}
        />

        <DriverDetailsModal
          open={detailsModalOpen}
          onOpenChange={setDetailsModalOpen}
          driver={detailsDriver}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          adminId={AdminId}
          onOpenConfig={(driverCode) => {
            setConfigDriverCode(driverCode);
            setConfigModalOpen(true);
          }}
          onEditDriver={(driverObj) => {
            setDetailsModalOpen(false);
            setEditDriver(driverObj);      // ✅ important
            setEditModalOpen(true);
          }}
        />
        <DriverConfigQuickAddModal
          open={quickConfigOpen}
          onOpenChange={setQuickConfigOpen}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          adminId={AdminId}
          drivers={drivers}
          onSuccess={() => fetchAllDriverConfigs(true)}
        />
        <DriverChargesModal
          open={chargesModalOpen}
          onOpenChange={setChargesModalOpen}
          baseurl={baseurl}
          token={token}
          setIsUnauthorised={setIsUnauthorised}
          adminId={AdminId}
          drivers={drivers}
          initialDriverCode={chargesDriverCode}
          onSuccess={() => fetchDriverCharges(true)}
        />



      </>)
  };
  useEffect(() => {
    if (activeTab === "Driver Charges") fetchDriverCharges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
  const filteredChargesRows = (chargesTabRows || []).filter((r) => {
    const q = chargesSearch.trim().toLowerCase();
    if (!q) return true;

    return [
      r.driverCode,
      r.name,
      r.teamName,
      String(r.per_day?.amount ?? ""),
      String(r.per_order?.amount ?? ""),
    ].some((v) => String(v || "").toLowerCase().includes(q));
  });


  return (
    <div className="p-4">
      <Toaster position="top-right" />

      <div className="flex justify-between items-center">
        <h1 className="text-xl font-semibold">Drivers</h1>
      </div>

      {renderTabNavigation()}
      {renderSearchAndFilters()}

      {Loading ? (
        <LoadingScreen />
      ) : (
        <>
          {activeTab === "list" && renderDriversTable()}
          {activeTab === "Kyc Details" && renderKycTable()}
          {activeTab === "Configuration" && (
            configTabLoading ? (
              <LoadingScreen />
            ) : (
              <DriverConfigTable
                rows={filteredConfigRows}

                deletingId={deletingConfigId}
                onEdit={(driverCode) => {
                  setConfigDriverCode(driverCode);
                  setConfigModalOpen(true);
                }}
                onDelete={handleDeleteConfig}
              />
            )
          )}
          {activeTab === "Driver Charges" && (
            chargesTabLoading ? (
              <LoadingScreen />
            ) : (
              <DriverChargesBoard
                rows={filteredChargesRows}
                onEditDriver={(driverCode) => {
                  setChargesDriverCode(driverCode);
                  setChargesModalOpen(true);
                }}
              />
            )
          )}


          {activeTab !== "Configuration" && renderPagination()}

        </>
      )}

      {renderModals()}
    </div>
  );
}